import { useForm } from "react-hook-form";
import { useTranslation } from "../../core/translation.core";
import { TagFormData } from "../../types/tag";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { post } from "../../core/fetch.core";
import Layout from "../../components/layouts/layout.comp";
import TagEditor from "../../components/tag/tagEditor.comp";

export default function CreateTagPage() {
  const { t, msg } = useTranslation();
  const methods = useForm<TagFormData>();
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: TagFormData) => {
      await post("/admin/tag/create", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tags"] });
      push("/tags");
    },
    onError: (error) => {
      console.log(error);
      alert(error.message);
    },
  });

  return (
    <Layout title={t(msg.tag.add)}>
      <TagEditor methods={methods} mutation={mutation} btnName={t(msg.form.create)} />
    </Layout>
  );
}
